import { Paper, PaperProps } from "@mui/material";
import { useRef } from "react";
import { MenuStateType } from "../reducers/menu";
import Draggable from "react-draggable";
import { drawerWidth } from "../utils/Common";

export default function FormModalPaperComponent(props: PaperProps, menuState: MenuStateType | undefined) {
    const nodeRef = useRef<HTMLDivElement>(null);
    return (
        <Draggable
            nodeRef={nodeRef as React.RefObject<HTMLDivElement>}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"],[class*="MuiButtonBase-root"]'}
        >
            <Paper {...props} sx={{minWidth: menuState?.showSidebar ? `calc(45vw - ${drawerWidth}px)` : "45vw"}} ref={nodeRef} />
        </Draggable>
    );
}